const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const jsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      url: siteUrl,
      name: 'CYFA Sponsorship',
      description:
        'Sponsor the Caledonia Youth Football Association and put your business in front of 1,000+ Cal families.',
      inLanguage: 'en-US',
    },
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/#webpage`,
      url: siteUrl,
      name: 'Caledonia Youth Football Sponsorship | CYFA – Support Cal Kids',
      description:
        'Become a sponsor of the Caledonia Youth Football Association (CYFA). Support Cal kids and put your business in front of hundreds of Caledonia families. Helmet sponsorships, field signage, jersey logos & more.',
      isPartOf: { '@id': `${siteUrl}/#website` },
      inLanguage: 'en-US',
      dateModified: '2025-07-22',
    },
    {
      '@type': 'SportsOrganization',
      '@id': `${siteUrl}/#organization`,
      name: 'Caledonia Youth Football Association',
      alternateName: 'CYFA',
      url: siteUrl,
      logo: 'https://static.readdy.ai/image/68c02a6c7db1e4f446ae7031426f220f/b4d28f31b85e5c51af718a9e77abeb89.png',
      description:
        'The Caledonia Youth Football Association (CYFA) is a nonprofit youth sports organization serving 300+ young athletes in Caledonia, Michigan.',
      sport: 'American Football',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Caledonia',
        addressRegion: 'MI',
        addressCountry: 'US',
      },
      areaServed: {
        '@type': 'City',
        name: 'Caledonia',
        containedInPlace: {
          '@type': 'State',
          name: 'Michigan',
        },
      },
      sameAs: [],
    },
    {
      '@type': 'FAQPage',
      '@id': `${siteUrl}/#faq`,
      mainEntity: [
        {
          '@type': 'Question',
          name: 'What sponsorship levels does CYFA offer?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'CYFA offers multiple Caledonia youth football sponsorship tiers including helmet sponsorships, field signage, jersey logo placement, and more — each designed to put your business in front of Cal families.',
          },
        },
        {
          '@type': 'Question',
          name: 'Where does my CYFA sponsorship money go?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '100% of sponsorship funds go directly back to the Caledonia youth football program — covering helmets, jerseys, field maintenance, referees, practice equipment, team travel, athletic training, and end-of-season awards.',
          },
        },
        {
          '@type': 'Question',
          name: 'How do I become a CYFA sponsor?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Simply fill out the sponsorship interest form on this page. A CYFA representative will follow up with you to confirm your Caledonia community sponsorship details.',
          },
        },
        {
          '@type': 'Question',
          name: 'How many families will see my sponsorship?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'CYFA reaches 1,000+ Cal families across the Caledonia community through games, events, and digital channels, giving your business significant local visibility.',
          },
        },
      ],
    },
  ],
};

export default function SeoJsonLd() {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd, null, 2) }}
    />
  );
}
